import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidStar",
  "use": "SolidStar-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"SolidStar\"><path d=\"M12 17.53l-4.334 2.403a.535.535 0 0 1-.789-.557l.835-5.13-3.56-3.657a.538.538 0 0 1 .303-.906l4.895-.75 2.165-4.624a.535.535 0 0 1 .97 0l2.165 4.624 4.895.75a.537.537 0 0 1 .303.906l-3.56 3.658.835 5.129a.537.537 0 0 1-.789.557L12 17.53z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol